import { isNotNull, isTokenExpire, logOutUser, isFormData } from "src/utils/constants";
import { getBaseURL } from './appConfig';
import { store } from "src/redux/store";
import { showLoader, hideLoader } from '../redux/reducers/loader.reducer';

const fetchRequest = {
    version: '/v1',

    get(api_endpoint) {
        return this.apiResponse('GET', api_endpoint);
    },

    post(api_endpoint, body) {
        return this.apiResponse('POST', api_endpoint, body);
    },

    put(api_endpoint, body) {
        return this.apiResponse('PUT', api_endpoint, body);
    },

    patch(api_endpoint, body) {
        return this.apiResponse('PATCH', api_endpoint, body);
    },

    delete(api_endpoint, body = {}) {
        return this.apiResponse('DELETE', api_endpoint, body);
    },

    getAll(api_endpoints) {
        return this.allApiResponse('GET', [...api_endpoints]);
    },

    resolveEndpointUrl(api_endpoint) {
        let endpoint = api_endpoint;

        // Upgrade http:// to https:// to prevent CORS preflight redirect errors
        if (typeof endpoint === 'string' && endpoint.startsWith('http://')) {
            endpoint = endpoint.replace(/^http:\/\//i, 'https://');
        }

        if (endpoint?.startsWith('http://') || endpoint?.startsWith('https://')) {
            const apiIndex = endpoint.indexOf('/api/');
            let isOurApi = false;
            try {
                const parsed = new URL(endpoint);
                const baseParsed = new URL(getBaseURL());
                isOurApi = parsed.hostname === baseParsed.hostname || parsed.hostname.endsWith('kurumatravels.in');
            } catch (e) {
                isOurApi = typeof endpoint === 'string' && endpoint.includes('kurumatravels.in');
            }

            if (apiIndex !== -1 && isOurApi) {
                const apiPath = endpoint.substring(apiIndex + 4);
                return getBaseURL() + apiPath;
            }
            return endpoint;
        }

        if (endpoint?.startsWith(this.version)) {
            return getBaseURL() + endpoint;
        }

        return getBaseURL() + this.version + (endpoint?.startsWith('/') ? endpoint : `/${endpoint || ''}`);
    },

    apiResponse(method, api_endpoint, body) {
        let url = this.resolveEndpointUrl(api_endpoint);
        let formData = isFormData(body);
        let headers = {};

        if (!formData) {
            headers = {
                "Content-Type": "application/json",
                "Accept": "application/json",
                'x-platform': 'web',
                'x-app-type': 'admin',
                'x-app-version': '1.0.0',
                'x-os-version': navigator?.userAgentData?.platform ?? "unknown",
                'x-device-model': navigator?.userAgent ?? "unknown"
            }
        }

        return new Promise((resolve, reject) => {
            const requestOptions = {
                method: method,
                headers: headers,
                credentials: 'include'
            };

            if (body) {
                if (formData) {
                    requestOptions.body = body;
                } else {
                    requestOptions.body = JSON.stringify(body);
                }
            }

            store.dispatch(showLoader()); // Show loader
            fetch(url, requestOptions)
                .then(response => {
                    return response.json();
                })
                .then(responseJson => {
                    // Check for token expiration
                    if (isTokenExpire(responseJson, api_endpoint) && isNotNull(store?.getState()?.authReducer?.data)) {
                        logOutUser();
                    }
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {
                    store.dispatch(hideLoader()); // Hide loader in all cases
                });
        });
    },

    allApiResponse(method, api_endpoints) {
        let urls = api_endpoints.map((i) => getBaseURL() + this.version + i);

        let headers = {
            "Content-Type": "application/json",
            "Accept": "application/json",
            'x-platform': 'web',
            'x-app-type': 'admin',
            'x-app-version': '1.0.0',
            'x-os-version': navigator?.userAgentData?.platform ?? "unknown",
            'x-device-model': navigator?.userAgent ?? "unknown"
        };

        const requestOptions = {
            method: method,
            headers: headers,
            credentials: 'include'
        };

        // Wrap the whole thing in a new Promise
        return new Promise((resolve, reject) => {
            // Use Promise.all to handle multiple fetch requests
            Promise.all(
                urls.map((url) => fetch(url, requestOptions))
            )
                .then((responses) => {
                    // Wait for all responses to be converted to JSON
                    return Promise.all(responses.map((res) => res.json()));
                })
                .then((data) => {
                    data.forEach((response) => {
                        // Check for token expiration
                        if (isTokenExpire(response, getBaseURL()) && isNotNull(store?.getState()?.authReducer?.data)) {
                            logOutUser();
                        }
                    });

                    // Resolve the data
                    resolve(data);
                })
                .catch((error) => {
                    // Reject the promise if any fetch fails
                    reject(error);
                });
        });
    }

};

export default fetchRequest;